import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs"
import {CourseProgress} from "../apiConfigs"

export const CourseProgressApi = createAsyncThunk(
    'auth/analytics/CourseProgressApi',
    async (requestData, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.get(CourseProgress, { params: requestData })
            return response?.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)

const CourseProgressSlice = createSlice({
    name: 'analytics/CourseProgressApi',
    initialState: { result: [], loading: false, error: null, message: "", total: 0 },
    extraReducers: (builder) => {
        builder.addCase(CourseProgressApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(CourseProgressApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.result
            state.message = action?.payload?.message
            state.total = action?.payload?.count
        })
        builder.addCase(CourseProgressApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})

export const CourseProgressReducer = CourseProgressSlice.reducer